import { render, staticRenderFns } from "./shop-management.vue?vue&type=template&id=59c86d8f&scoped=true"
import script from "./shop-management.vue?vue&type=script&lang=js"
export * from "./shop-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c86d8f",
  null
  
)

export default component.exports